import classnames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { WATCH_TYPE } from 'src/app/constants/video';
import { formatDurationTime } from 'src/app/helpers/format';
import { withStyles } from 'src/app/helpers/styles';

interface MyProps {
  duration: number;
  type?: WATCH_TYPE;
  className?: string;
}

@withStyles(require('./OverlayDuration.scss'))
export class OverlayDuration extends React.Component<MyProps> {
  render(): JSX.Element {
    const isLive = this.props.type === WATCH_TYPE.LIVE;
    const className = classnames(
      'bg-jetblack ta-center fw-700 radius-small position-absolute lh-1 opacity-80 fs-12 px-12 py-4 overlay-duration d-flex ai-center', {
        'bg-red': isLive,
        'opacity-100': isLive
      }, this.props.className);
    return (
      <div className={className}>
        {this.durationText}
      </div>
    );
  }

  private get durationText(): JSX.Element | string {
    const { duration, type } = this.props;
    return type === WATCH_TYPE.LIVE
      ? <FormattedMessage id="label.live.now" />
      : formatDurationTime(duration);
  }
}
